import React from "react";
import "./StepProcess.css";
import step1 from "../step1.jpeg";
import step2 from "../step2.jpg";
import step3 from "../step3.jpg";
import step4 from "../step4.jpeg";

const steps = [
  {
    number: "01",
    title: "Approach Us",
    desc: "Connect with us and share your requirements. We understand your budget, preferred location, and expectations in detail.",
    img: step1
  },
  {
    number: "02",
    title: "Find Suitable Land",
    desc: "We carefully shortlist verified properties and lands that perfectly align with your requirements.",
    img: step2
  },
  {
    number: "03",
    title: "Plan Site Visit",
    desc: "We arrange a comfortable land visit together so you can inspect and evaluate confidently.",
    img: step3
  },
  {
    number: "04",
    title: "Documentation & Registration",
    desc: "We ensure smooth legal verification, documentation, and secure registration with complete transparency.",
    img: step4
  }
];

const StepProcess = () => {
  return (
    <section className="luxury-process">
      <h2 className="luxury-title">Our Simple 4-Step Process</h2>

      <div className="luxury-container">
        {steps.map((step, index) => (
          <div 
            key={index} 
            className={`luxury-step ${index % 2 === 0 ? "left" : "right"}`}
          >
            <div className="luxury-image">
              <img src={step.img} alt={step.title} />
            </div>

            <div className="luxury-content">
              <span className="luxury-number">{step.number}</span>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StepProcess;